module.exports = __webpack_public_path__ + "img/fail.a26a5467.png";